import { noop } from 'lodash';
import { createContext, PropsWithChildren, useState } from 'react';

import { TypeaheadSelectInputOption } from '@/components/form/baseInputs/inputTypes';
import { useGuardedContext } from '@/hooks/useGuardedContext';

import {
  EntityOrClientProfileId,
  EstateWaterfallHypotheticalGratModalContextType,
  SourceValues,
} from './EstateWaterfallHypotheticalGratModal.types';

const DEFAULT_IS_LOADING = true;

const EstateWaterfallHypotheticalGratModalContext =
  createContext<EstateWaterfallHypotheticalGratModalContextType>({
    waterfallId: '',
    gratId: '',
    isLoading: DEFAULT_IS_LOADING,
    setIsLoading: noop,
    initialSourceId: undefined,
    gratOptions: [],
    setGratOptions: noop,
    sourceEntityOptions: [],
    setSourceEntityOptions: noop,
    sourceIndividualOptions: [],
    setSourceIndividualOptions: noop,
    sourceValues: {},
    setSourceValues: noop,
    fundingId: '',
    setFundingId: noop,
  });

export interface EstateWaterfallHypotheticalGratModalContextProviderProps
  extends PropsWithChildren {
  waterfallId: string;
  gratId: string | null;
  initialSourceId?: string;
}

export function EstateWaterfallHypotheticalGratModalContextProvider(
  props: EstateWaterfallHypotheticalGratModalContextProviderProps
) {
  const [isLoading, setIsLoading] = useState(DEFAULT_IS_LOADING);
  const [gratOptions, setGratOptions] = useState<
    TypeaheadSelectInputOption<string>[]
  >([]);
  const [sourceEntityOptions, setSourceEntityOptions] = useState<
    TypeaheadSelectInputOption<string>[]
  >([]);
  const [sourceIndividualOptions, setSourceIndividualOptions] = useState<
    TypeaheadSelectInputOption<string>[]
  >([]);
  const [sourceValues, setSourceValues] = useState<
    Record<EntityOrClientProfileId, SourceValues>
  >({});
  const [fundingId, setFundingId] = useState('');

  return (
    <EstateWaterfallHypotheticalGratModalContext.Provider
      value={{
        waterfallId: props.waterfallId,
        gratId: props.gratId,
        isLoading,
        setIsLoading,
        initialSourceId: props.initialSourceId,
        gratOptions,
        setGratOptions,
        sourceEntityOptions,
        setSourceEntityOptions,
        sourceIndividualOptions,
        setSourceIndividualOptions,
        sourceValues,
        setSourceValues,
        fundingId,
        setFundingId,
      }}
    >
      {props.children}
    </EstateWaterfallHypotheticalGratModalContext.Provider>
  );
}

export function useEstateWaterfallHypotheticalGratModalContext() {
  return useGuardedContext(
    EstateWaterfallHypotheticalGratModalContext,
    'EstateWaterfallHypotheticalGratModalContextProvider'
  );
}
